import React from 'react';

import { CreateCaseState } from 'features/support/core/types';
import { Platform, StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { useGetAndLogUserErrorMessage } from 'hooks/log-user-error-message';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

import { ICreateSupportCaseFeedbackProps } from './types';

export const CreateSupportCaseFeedback = ({
  createCaseState,
  createCaseErrorMessage: createCaseErrorMessageProp,
}: ICreateSupportCaseFeedbackProps) => {
  const createCaseErrorMessage = createCaseErrorMessageProp || t('errorCreatingSupportCase');

  const getErrorMessage = useGetAndLogUserErrorMessage({ message: createCaseErrorMessage });

  const createCaseStateSuccessMessage = (
    <Box style={styles.successMessage}>
      <Typography>{t('successfullyCreatedSupportCase')}</Typography>
      <Typography>{t('waitForReply')}</Typography>
    </Box>
  );

  const isCreateCaseStateSuccess = createCaseState === CreateCaseState.SUCCESS;
  const isCreateCaseStateError = createCaseState === CreateCaseState.ERROR;
  return (
    <Box style={styles.container} testID="after-submission-message">
      {isCreateCaseStateError && (
        <Typography
          style={styles.errorMessage}
          variant="copyOne"
          color={getDesignToken('text-error')}
        >
          {getErrorMessage()}
        </Typography>
      )}
      {isCreateCaseStateSuccess && createCaseStateSuccessMessage}
    </Box>
  );
};

const styles = StyleSheet.create({
  container: { alignItems: 'center', marginBottom: 24 },
  errorMessage: { marginHorizontal: 16 },
  successMessage: {
    paddingBottom: 8,
    paddingHorizontal: Platform.select({ android: 16, default: 24 }),
  },
});
